import { useEffect, useState } from 'react';

export default function Preloader() {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [status, setStatus] = useState('Initializing system...');

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => setIsVisible(false), 150); // Minimal exit delay
          return 100;
        }
        
        // Update status messages based on progress
        if (prev > 20 && prev < 50) setStatus('Collecting travel intelligence...');
        if (prev > 50 && prev < 80) setStatus('Synchronizing movement nodes...');
        if (prev > 80) setStatus('Finalizing orchestration...');
        
        // Rapid increment for performance perception
        return prev + Math.random() * 25; 
      });
    }, 80); // Fast interval

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {isVisible && (
        <div className="fixed inset-0 z-[99999] bg-black flex flex-col items-center justify-center overflow-hidden">
          {/* Background depth orbs */}
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/5 blur-[120px] rounded-full" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-indigo-500/10 blur-[80px] rounded-full" />
          </div>

          <div className="relative z-10 flex flex-col items-center">
            {/* Minimal Logo / Text */}
            <div className="mb-12 text-center">
              <h1 className="font-serif text-3xl tracking-tighter text-white/90 mb-1">
                Voyara AI
              </h1>
              <p className="text-[10px] tracking-[0.4em] uppercase text-white/45 font-medium">
                Eclipse Group
              </p>
            </div>

            {/* Central Loader Core */}
            <div className="relative w-24 h-24 mb-16">
              {/* Outer ring */}
              <div className="absolute inset-0 border border-white/5 rounded-full" />
              {/* Spinning accent */}
              <div className="absolute inset-0 border-t border-white/20 rounded-full" />
              {/* Inner core */}
              <div className="absolute inset-6 bg-gradient-to-br from-white/10 to-transparent rounded-full flex items-center justify-center border border-white/5">
                 <div className="w-1.5 h-1.5 bg-white/40 rounded-full shadow-[0_0_15px_rgba(255,255,255,0.5)]" />
              </div>
            </div>

            {/* Progress Text */}
            <div className="flex flex-col items-center gap-4">
              <div className="h-[1px] w-48 bg-white/5 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent" />
              </div>

              <div className="flex flex-col items-center gap-1.5 h-[32px]">
                <span className="text-[11px] font-medium tracking-[0.05em] text-white/60 tabular-nums w-[40px] text-center">
                  {Math.round(progress)}%
                </span>
                <div className="h-[16px] flex items-center justify-center overflow-visible">
                  <span
                    key={status}
                    className="text-[10px] tracking-[0.15em] uppercase text-white/45 font-light whitespace-nowrap"
                  >
                    {status}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
